<ng-container *ngIf="step === 0">
  <header class="oswald primary text-center interview-request-title">
    Confirmation
  </header>
  <hr style="margin: 1.25rem 0" />
  <div class="interview-request-content mb-3">
    Almost done. Please confirm your information.
  </div>
  <app-content-header
    text="Location"
    [showEdit]="true"
    (editClicked)="handlePageContent(1)"
    firebase="requestInterview_editCampLocation"
  ></app-content-header>
  <div
    *ngIf="interviewRequestService.selectedLocation; else default"
    class="px-3 mb-4"
  >
    <span
      class="oswald primary"
      style="font-size: 1.125rem"
    >{{
      interviewRequestService.selectedLocation.name
      }}</span>
    <br />
    <span
      class="lato bold teal"
      style="font-size: 1.125rem"
    >{{
      interviewRequestService.selectedLocation.address1 +
      " " +
      interviewRequestService.selectedLocation.address2
      }}</span>
    <br />
    <span
      class="lato teal"
      style="font-size: 0.813rem"
    >{{
      interviewRequestService.selectedLocation.city +
      ", " +
      interviewRequestService.selectedLocation.state +
      " " +
      interviewRequestService.selectedLocation.zipcode
      }}</span>
    <br />
    <img
      src="assets/images/ico_phone_red.png"
      alt="Phone Icon"
      height="16"
      class="mr-1"
    />
    <a
      [href]="'tel:' + interviewRequestService.selectedLocation.telephone"
      class="link"
    >{{ interviewRequestService.selectedLocation.telephone | phoneNumber }}</a>
  </div>
  <ng-template #default>
    <div
      *ngIf="myProfileService.preferredLocation$ | async as preferredLocation"
      class="px-3 mb-4"
    >
      <span
        class="oswald primary"
        style="font-size: 1.125rem"
      >{{
        preferredLocation.name
        }}</span>
      <br />
      <span
        class="lato bold teal"
        style="font-size: 1.125rem"
      >{{
        preferredLocation.address1 + " " + preferredLocation.address2
        }}</span>
      <br />
      <span
        class="lato teal"
        style="font-size: 0.813rem"
      >{{
        preferredLocation.city +
        ", " +
        preferredLocation.state +
        " " +
        preferredLocation.zipcode
        }}</span>
      <br />
      <img
        src="assets/svg/ico_phone_red.svg"
        alt="Phone Icon"
        height="16"
        class="mr-1"
      />
      <a
        [href]="'tel:' + preferredLocation.telephone"
        class="link"
      >{{ preferredLocation.telephone | phoneNumber }}</a>
    </div>
  </ng-template>

  <app-content-header text="Camper(s)"></app-content-header>
  <div
    *ngFor="let pet of selectedPets; let isLastChild = last"
    [style.marginBottom]="isLastChild ? '0' : '0.5rem'"
  >
    <app-pet-tile-review [petInfo]="pet"></app-pet-tile-review>
  </div>
  <hr style="margin: 1.25rem 0" />
  <div class="pet-info-label">Reminder:</div>
  <div class="interview-request-content">
    This is a request only. You will be contacted shortly by a Camp Counselor to
    schedule the day and time for your interview. We can't wait to meet you and
    your pup!
  </div>
  <div style="margin-top: 2.5rem">
    <hr />
    <footer class="footer-action">
      <button
        class="btn btn-danger btn-block"
        (click)="submitRequest()"
      >
        Submit Request
      </button>
    </footer>
  </div>
</ng-container>
<ng-container *ngIf="step === 1">
  <app-interview-request-change-location (changeStep)="handlePageContent($event)">
  </app-interview-request-change-location>
</ng-container>
<ng-container *ngIf="step === 2">
  <app-interview-request-search-location (changeStep)="handlePageContent($event)">
  </app-interview-request-search-location>
</ng-container>
